var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19712 17.1971C3.67916 16.4318 4.61362 15.3111 4.66859 14.0849C4.72779 13.2181 4.04699 10.4401 5.69182 8.1441C9.99208 2.07638 23.7936 3.98756 23.9585 12.9644C24.0134 17.1674 21.4679 18.5204 20.7322 21.0448C20.3643 22.3682 20.4447 23.8736 21.1001 24.8926C21.1593 24.9983 21.7216 26.1442 17.9837 28.3133C14.7025 30.1992 13.2014 30.656 12.3473 30.3769C11.9498 30.2543 11.9498 29.9667 11.9498 29.9667C11.8357 28.3895 11.7553 22.8291 9.48466 23.2647C6.62205 23.8482 4.10619 24.0808 4.95609 20.715C4.27109 20.715 3.99205 20.1315 4.55865 19.8016C3.99205 19.8016 3.87789 19.2858 4.24998 18.956C4.24576 18.4443 2.06392 18.9815 3.19712 17.1971Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5774 0.00433573C20.1947 0.376433 24.0552 3.30251 25.2984 7.23489C25.4252 7.70424 25.5394 8.47364 25.6113 9.07407C25.6663 9.53496 25.2688 9.94101 24.7444 9.94101C3.36579 9.94101 3.36577 9.94101 3.36577 9.94101C-1.25161 9.94101 1.4884 9.94101 1.4884 9.94101C0.659634 9.94101 0 9.36177 0 8.60912C0 7.80995 0.659634 7.23056 1.4884 7.23056C6.52016 7.23056 3.78014 7.23056 3.78014 7.23056C5.02328 3.29817 8.82036 0.372097 13.5012 0H15.5774V0.00433573Z",
    fill: "#80ACD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkers);
export default __webpack_public_path__ + "static/media/workers.484507a25bcb474646a95fe032216de4.svg";
export { ForwardRef as ReactComponent };